import { UserInfo } from './data';
import jwtDecode from 'jwt-decode';

export class UserManager {
    static getUserInfo(): UserInfo | null {
        try {
            let tokenValor = this.getToken();

            if(!tokenValor) {
                return null;
            }

            let r = jwtDecode(tokenValor) as UserInfo;

            r.empresaId = +r.empresaId;
            r.id = +r.id;

            return r;

        } catch (Error) {
            return null;
        }

        return null;
    }

    static getToken(): string | null {
        return localStorage.getItem('tokenValor') ?? sessionStorage.getItem('tokenValor');
    }
}